<template>
  <header class="flex-row">
    <a id="SkipToContentLink" href="#MainContent">{{ t('SkipToContent') }}</a>
    <div id="EnvironmentInfo" v-if="environmentName">{{ environmentName }}</div>
    <div class="headerleft flex-grow">
      <div class="logo" :class="getLogoLanguage"></div>
      <div id="displayName" :aria-label="t('UserName')">{{ getUserName }}</div>
    </div>
    <language-selector v-if="showLanguageSelector"></language-selector>
    <button v-if="showLogoutButton" id="logout" @click="logout" :title="t('HeaderLogoutButtonAlt')"></button>
    <div v-if="showInfoButton" id="info" :title="t('HeaderInfoButtonAlt')">
      <router-link :to="{ name: 'info', params: {tenantId: tenantId}, query: {lang: locale} }">
      </router-link>
    </div>
  </header>
</template>

<script src="./topmenu.ts" />

